// extracted by mini-css-extract-plugin
export var skipAnimation = "_38-0";